var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":"Srikung","title":"Srikung Customer Relation Management"}},[_c('template',{slot:"links"},[_c('sidebar-item',{class:_vm.lvl != 999 && _vm.lvl != 0 ? 'none' : '',attrs:{"link":{
          name: 'หน้าแรก',
          icon: 'ni ni-tv-2 text-primary',
          path: '/dashboard',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'ข้อมูลลูกค้า พรบ',
          icon: 'ni ni-bullet-list-67 text-green',
          path: '/customerWsu',
        }}}),_c('sidebar-item',{class:_vm.lvl != 999 && _vm.lvl != 0 ? 'none' : '',attrs:{"link":{
          name: ' -  บันทึกข้อมูลใหม่',
          icon: '',
          path: '/customerWsuAddNew',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: ' -  ดุใบเตือนต่ออายุ',
          icon: '',
          path: '/customerWsuReminder',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'ข้อมูลลูกค้า ประกัน',
          icon: 'ni ni-bullet-list-67 text-yellow',
          path: '/customerInsurance',
        }}}),_c('sidebar-item',{class:_vm.lvl != 999 && _vm.lvl != 0 ? 'none' : '',attrs:{"link":{
          name: ' -  ประวัติการแจ้งงาน',
          icon: '',
          path: '/customerInsuranceHistory',
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: ' -  ดุใบเตือนต่ออายุ',
          icon: '',
          path: '/customerInsuranceReminder',
        }}}),_c('sidebar-item',{class:_vm.lvl != 999 && _vm.lvl != 0 ? 'none' : '',attrs:{"link":{
          name: 'แจ้งงาน',
          icon: 'ni ni-collection text-black',
          path: '/line',
        }}}),_c('sidebar-item',{class:_vm.lvl != 999 && _vm.lvl != 0 ? 'none' : '',attrs:{"link":{
          name: 'ใบเสร็จรับเงิน',
          icon: 'ni ni-single-copy-04 text-orange',
          path: '/receipt',
        }}}),_c('sidebar-item',{class:_vm.lvl != 999 && _vm.lvl != 0 ? 'none' : '',attrs:{"link":{
          name: 'คำนวนภาษี',
          icon: 'ni ni-tag text-red',
          path: '/calculator',
        }}}),_c('sidebar-item',{class:_vm.lvl != 999 && _vm.lvl != 0 ? 'none' : '',attrs:{"link":{
          name: 'เอกสารสำเนาลูกค้า',
          icon: 'ni ni-image text-blue',
          path: '/document',
        }}}),_c('sidebar-item',{class:_vm.lvl != 999 ? 'none' : '',attrs:{"link":{
          name: 'ตัวแทน',
          icon: 'ni ni-circle-08 text-black',
          path: '/agent',
        }}}),_c('sidebar-item',{class:_vm.lvl != 999 ? 'none' : '',attrs:{"link":{
          name: 'พนักงาน',
          icon: 'ni ni-single-02 text-pink',
          path: '/employee',
        }}}),_c('sidebar-item',{class:_vm.lvl != 999 ? 'none' : '',attrs:{"link":{
          name: 'ประวัติ',
          icon: 'ni ni-chart-bar-32 text-green',
          path: '/logs',
        }}})],1)],2),_c('div',{staticClass:"main-content",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('div',{on:{"click":_vm.toggleSidebar}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }